import {FC, ReactElement} from 'react'

import {Trans} from '@/i18n'
import {Locale, QueryLink} from '@/utils/constants'
import {useLanguage} from '@/utils/i18n/language'

import {TransLink} from '../../TransLink'

type WhyTramaComparisonBenefitTransProps = {
  description: string
  numOfRegisteredTrademarks: number
  linkHrefs?: ({[key in Locale]?: string} | string)[]
  isLocalizedLink?: boolean
}

export const WhyTramaComparisonBenefitTrans: FC<WhyTramaComparisonBenefitTransProps> = ({
  description,
  numOfRegisteredTrademarks,
  linkHrefs,
  isLocalizedLink,
}) => {
  const language = useLanguage()
  return (
    <Trans
      i18nKey={description}
      values={{number: numOfRegisteredTrademarks}}
      components={
        linkHrefs
          ? linkHrefs.reduce((acc, link, i) => {
              const href =
                typeof link === 'string'
                  ? link
                  : 'pathname' in link
                  ? (link as QueryLink)
                  : link[language] ?? link[Locale.en]

              if (href) {
                acc[i + 1] = <TransLink key={i} href={href} isLocalized={isLocalizedLink} />
              }
              return acc
            }, {} as Record<number, ReactElement>)
          : {}
      }
    />
  )
}
